import PropTypes from "prop-types";
import { Link } from "@mui/material";
import { NavLink } from "react-router-dom";

import { useScreen } from "hooks";

import Slide from "./components/Slide";
import Media from "./components/Media";
import Content from "./components/Content";

const FeaturedPanelSlide = ({
  item,
  logo,
  title,
  description,
  backgroundColor,
  bottomBackgroundColor,
  link,
  video,
  image,
  onVideoDuration,
  onClick,
}) => {
  const { isMobile } = useScreen();
  const handleClick = () => (onClick ? onClick(item) : null);

  const slideContent = (
    <Slide isMobile={isMobile}>
      <Media
        video={video}
        image={image}
        title={title}
        background={backgroundColor}
        bottomBackground={bottomBackgroundColor}
        onVideoDuration={onVideoDuration}
      />
      <Content logo={logo} title={title} description={description} />
    </Slide>
  );

  if (link) {
    return (
      <Link to={link} component={NavLink} onClick={handleClick}>
        {slideContent}
      </Link>
    );
  }

  return slideContent;
};

FeaturedPanelSlide.propTypes = {
  item: PropTypes.shape(),
  logo: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  video: PropTypes.string,
  image: PropTypes.string,
  backgroundColor: PropTypes.string,
  bottomBackgroundColor: PropTypes.string,
  link: PropTypes.string,
  onVideoDuration: PropTypes.func,
  onClick: PropTypes.func,
};

export default FeaturedPanelSlide;
